import { currentLang } from '../../i18nInit'
import { Lang } from '../../services/api.types'

const getLocalizedUnits = (locale: Lang) => {
  let lang = locale.toLowerCase()
  if (locale === Lang.ZH_HANS) lang = 'zh-Hans'
  try {
    // TODO: We need to use static paths for webpack. Otherwise, we'd end up with 50MB build.
    //return require(`cldr-units-modern/main/${lang}/units.json`).main[lang].units
    switch (locale) {
      default:
      case Lang.EN:
        return require(`cldr-units-modern/main/en/units.json`).main[lang].units
      case Lang.AR:
        return require(`cldr-units-modern/main/ar/units.json`).main[lang].units
      case Lang.BG:
        return require(`cldr-units-modern/main/bg/units.json`).main[lang].units
      case Lang.BS:
        return require(`cldr-units-modern/main/bs/units.json`).main[lang].units
      case Lang.CS:
        return require(`cldr-units-modern/main/cs/units.json`).main[lang].units
      case Lang.DA:
        return require(`cldr-units-modern/main/da/units.json`).main[lang].units
      case Lang.DE:
        return require(`cldr-units-modern/main/de/units.json`).main[lang].units
      case Lang.EL:
        return require(`cldr-units-modern/main/el/units.json`).main[lang].units
      case Lang.ES:
        return require(`cldr-units-modern/main/es/units.json`).main[lang].units
      case Lang.ET:
        return require(`cldr-units-modern/main/et/units.json`).main[lang].units
      case Lang.FI:
        return require(`cldr-units-modern/main/fi/units.json`).main[lang].units
      case Lang.FR:
        return require(`cldr-units-modern/main/fr/units.json`).main[lang].units
      case Lang.HR:
        return require(`cldr-units-modern/main/hr/units.json`).main[lang].units
      case Lang.HU:
        return require(`cldr-units-modern/main/hu/units.json`).main[lang].units
      case Lang.ID:
        return require(`cldr-units-modern/main/id/units.json`).main[lang].units
      case Lang.IT:
        return require(`cldr-units-modern/main/it/units.json`).main[lang].units
      case Lang.JA:
        return require(`cldr-units-modern/main/ja/units.json`).main[lang].units
      case Lang.KO:
        return require(`cldr-units-modern/main/ko/units.json`).main[lang].units
      case Lang.LT:
        return require(`cldr-units-modern/main/lt/units.json`).main[lang].units
      case Lang.LV:
        return require(`cldr-units-modern/main/lv/units.json`).main[lang].units
      case Lang.NL:
        return require(`cldr-units-modern/main/nl/units.json`).main[lang].units
      case Lang.NO:
        return require(`cldr-units-modern/main/no/units.json`).main[lang].units
      case Lang.PL:
        return require(`cldr-units-modern/main/pl/units.json`).main[lang].units
      case Lang.PT:
        return require(`cldr-units-modern/main/pt/units.json`).main[lang].units
      case Lang.RO:
        return require(`cldr-units-modern/main/ro/units.json`).main[lang].units
      case Lang.RU:
        return require(`cldr-units-modern/main/ru/units.json`).main[lang].units
      case Lang.SK:
        return require(`cldr-units-modern/main/sk/units.json`).main[lang].units
      case Lang.SL:
        return require(`cldr-units-modern/main/sl/units.json`).main[lang].units
      case Lang.SQ:
        return require(`cldr-units-modern/main/sq/units.json`).main[lang].units
      case Lang.SR:
        return require(`cldr-units-modern/main/sr/units.json`).main[lang].units
      case Lang.SV:
        return require(`cldr-units-modern/main/sv/units.json`).main[lang].units
      case Lang.TH:
        return require(`cldr-units-modern/main/th/units.json`).main[lang].units
      case Lang.TR:
        return require(`cldr-units-modern/main/tr/units.json`).main[lang].units
      case Lang.UK:
        return require(`cldr-units-modern/main/uk/units.json`).main[lang].units
      case Lang.VI:
        return require(`cldr-units-modern/main/vi/units.json`).main[lang].units
      case Lang.ZH_HANS:
        return require(`cldr-units-modern/main/zh-Hans/units.json`).main[lang].units
    }
  } catch (ex) {
    console.error(`Units for ${lang} does not exist!`)
    return undefined
  }
}

const unitsShort = getLocalizedUnits(currentLang)

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getLocalizedDisplayUnit = (name: string, fallback: string) => {
  // @ts-ignore
  return capitalizeFirstLetter(unitsShort?.long[name]?.displayName || fallback)
}

export const getLocalizedDisplayUnitShort = (name: string, fallback: string) => {
  // @ts-ignore
  return capitalizeFirstLetter(unitsShort?.short[name]?.displayName || fallback)
}

// Test if units for all languages exists.
/*import { languages } from '../../i18nInit'
languages.forEach(({ lang, name }, index) => {
  name = 'length-point'
  const unitsShort2 = getLocalizedUnits(lang)
  console.log(lang, unitsShort2?.short[name]?.['unitPattern-count-other'])
})*/
//languages.forEach(({ lang, name }, index) => getLocalizedUnits(lang))

export const getLocalizedCountUnit = (name: string, fallback: string, length?: string) => {
  // @ts-ignore
  if (!length) length = 'short'
  return unitsShort?.[length]?.[name]?.['unitPattern-count-other']?.replace('{0}', '').trim() || fallback
}

export const unitsDisplayDurationMinuteLong = getLocalizedDisplayUnit('duration-minute', 'Minutes')
export const unitsDisplayDurationCalorieLong = getLocalizedDisplayUnit('energy-calorie', 'Calories')

export const unitsCountDurationDayLong = getLocalizedCountUnit('duration-day', 'days', 'long')
export const unitsCountDurationMinuteLong = getLocalizedCountUnit('duration-minute', 'minutes', 'long')
export const unitsCountEnergyCalorieLong = getLocalizedCountUnit('energy-calorie', 'calories', 'long')

export const unitsCountEnergyKilocalorieShort = getLocalizedCountUnit('energy-kilocalorie', 'kcal')
export const unitsCountMassKilogramShort = getLocalizedCountUnit('mass-kilogram', 'kg')
export const unitsCountMassPoundShort = getLocalizedCountUnit('mass-pound', 'lb')
export const unitsCountLengthFootShort = getLocalizedCountUnit('length-foot', 'ft')
export const unitsCountLengthInchShort = getLocalizedCountUnit('length-inch', 'in')
export const unitsCountLengthCentimeterShort = getLocalizedCountUnit('length-centimeter', 'cm')
export const unitsCountLengthKilometerShort = getLocalizedCountUnit('length-kilometer', 'km')
export const unitsCountLengthMileShort = getLocalizedCountUnit('length-mile', 'mi')
export const unitsCountDurationMinuteShort = getLocalizedCountUnit('duration-minute', 'minutes')

export const unitsCountPointsShortFunc = (value?: number) => {
  if (currentLang === Lang.EN) {
    return value === 1 ? `point` : `points`
  } else if (currentLang === Lang.ET) {
    return value === 1 ? `punkt` : `punkti`
  }
  return getLocalizedCountUnit('length-point', 'points', 'short')
}
export const unitsCountPointsShort = unitsCountPointsShortFunc()
export const unitsDisplayPointsShort = getLocalizedDisplayUnitShort('length-point', 'Points')
